"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_i18next_1 = require("react-i18next");
var numberHelpers_1 = require("../../../../helpers/numberHelpers");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var DailyPriceInput = function (_a) {
    var dailyPrice = _a.dailyPrice, onChange = _a.onChange, formikProps = _a.formikProps;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(!!Number(formikProps.values.apartment_info[0].daily_price_is_checked)), isChecked = _b[0], setIsChecked = _b[1];
    react_1.useEffect(function () {
        !isChecked && setIsChecked(!!dailyPrice);
    }, [dailyPrice]);
    var handleOnChange = function (value) {
        numberHelpers_1.onlyNumberAndADot(value) &&
            onChange(numberHelpers_1.replaceZeroToEmpty(isNaN(parseInt(value))
                ? numberHelpers_1.replaceFirstDotToEmpty(value)
                : value));
        formikProps.setFieldValue('apartment_info[0].daily_price_is_checked', !!value.length);
    };
    var handleCheckboxChange = function () {
        setIsChecked(!isChecked);
        formikProps.setFieldValue('apartment_info[0].daily_price_is_checked', !isChecked);
        if (!!dailyPrice) {
            formikProps.setFieldValue('apartment_info[0].daily_price', '');
        }
    };
    return (react_1.default.createElement(semantic_ui_react_1.Segment, { compact: true, className: styles_module_scss_1.default.segment },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.checkbox_Label, onClick: handleCheckboxChange },
            react_1.default.createElement(semantic_ui_react_1.Checkbox, { className: styles_module_scss_1.default.segment_checkbox, checked: isChecked }),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.input_label },
                t('fields.section4.daily_price'),
                "\u00A0\u00A0")),
        react_1.default.createElement("input", { className: styles_module_scss_1.default.rental_input, value: dailyPrice ? numberHelpers_1.parseNumberToComma(dailyPrice) : '', placeholder: "0.00", onChange: function (event) {
                return handleOnChange(numberHelpers_1.revertCommaNumber(event.target.value));
            } })));
};
exports.default = DailyPriceInput;
